module.exports = __webpack_public_path__ + "static/event-image-1-e3b643d62c2c3339ba4bf5ef514793a5.jpg";